import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
  getUserType,
} from '../redux/selectors/CarditByReceivingAirlineNumberedSelectors';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import CarditByReceivingAirlineReport from '../component/CarditByReceivingAirlineReport';

export function CarditByReceivingAirlineNumberedContainer(props) {
  return (
    <CarditByReceivingAirlineReport
      reportId={ReportDefinitions.CARDIT_BY_RECEIVING_AIRLINE_NUMBERED.id}
      generatedOnDateTime={props.generatedDateTime}
      isLoading={props.isLoading}
      data={props.data}
      columns={props.columns}
      userType={props.userType}
      className="carditBySendingPostReport"
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    userType: getUserType(state),
  };
}

CarditByReceivingAirlineNumberedContainer.propTypes = {
  generatedDateTime: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userType: PropTypes.string,
};

export default connect(mapStateToProps)(CarditByReceivingAirlineNumberedContainer);
